import { z } from 'zod'

export const AssetSchema = z.object({
  id: z.string().optional(), // Asset ID from the API
  filename: z.string(),
  thumbnail: z.string(), // Thumbnail filename (PNG, smaller than original SVG)
  translations: z.record(z.string(), z.string()).optional(), // locale -> translated name
})

export type Asset = z.infer<typeof AssetSchema>

export const AssetAlbumSchema = z.object({
  id: z.string().optional(), // Folder ID from the API (maps to index.json folders)
  folderName: z.string(),
  translations: z.record(z.string(), z.string()), // locale -> translated name
  assets: z.array(AssetSchema),
})

export type AssetAlbum = z.infer<typeof AssetAlbumSchema>

export const AssetsResponseSchema = z.object({
  engrave: z.array(AssetAlbumSchema),
  print: z.array(AssetAlbumSchema),
})

export type AssetsResponse = z.infer<typeof AssetsResponseSchema>

export type AssetType = 'engrave' | 'print'
